/* jshint -W024 */
import "./app/ceres/publicPath";
// =========================
// Polyfill's
// =========================

import "custom-event-polyfill";

// =========================
// Framework's
// =========================

import Vue from "vue";
import Vuex from "vuex";

import { mount } from "./mount";

Vue.prototype.$mount = mount;

window.Vue = Vue;
window.Vuex = Vuex;

import script2 from "./app/ceres/plugins/script2";
Vue.use(script2);

import "./app/eros/plugins/jQuery";

import "bootstrap";
import "owl.carousel";

import { getUrlParams } from "./app/eros/services/UrlService";
window.ceresEnv = getUrlParams().env;

// =========================
// COMPONENTS
// =========================
import CookieBar from "./app/eros/components/pageDesign/CookieBar.vue";
Vue.component("cookie-bar", CookieBar);
Vue.component("privacy-settings", () => import("./app/ceres/components/pageDesign/PrivacySettings.vue"));

import LoadingAnimation from "./app/ceres/components/pageDesign/LoadingAnimation.vue";
Vue.component("loading-animation", LoadingAnimation);
Vue.component("carousel", () => import("./app/ceres/components/pageDesign/Carousel.vue"));

Vue.component("step-by-step-navigation", () => import("./app/eros/components/category/StepByStepNavigation.vue"));
Vue.component("google-maps-widget", () => import("./app/ceres/components/common/GoogleMaps.vue"));
import LazyImg from "./app/eros/components/common/LazyImg.vue";
Vue.component("lazy-img", LazyImg);
import Intersect from "./app/ceres/components/common/Intersect.vue";
Vue.component("intersect", Intersect);
Vue.component("exchange-rate", () => import("./app/eros/components/common/ExchangeRate.vue"));
Vue.component("last-seen-item-list", () => import("./app/ceres/components/containers/LastSeenItemList.vue"));
import DynamicItemList from "./app/eros/components/itemList/dynamicItemList/DynamicItemList.vue";
Vue.component("dynamic-item-list", DynamicItemList);

Vue.component("dynamic-item-list-common", () =>
	import("./app/eros/components/itemList/dynamicItemList/Common/DynamicItemListCommon.vue")
);

// since basket isn't tpl.basket
Vue.component("dynamic-item-list-basket-tag", () =>
	import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketTag.vue")
);
Vue.component("dynamic-item-list-basket-prop", () =>
	import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketProp.vue")
);
Vue.component("dynamic-item-list-basket-simple", () =>
	import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketSimple.vue")
);

Vue.component("change-email-form", () => import("./app/ceres/components/customer/ChangeEmailForm.vue"));
import ReCaptcha from "./app/ceres/components/customer/ReCaptcha.vue";
Vue.component("recaptcha", ReCaptcha);
Vue.component("registration", () => import("./app/eros/components/customer/Registration.vue"));
Vue.component("reset-password-form", () => import("./app/eros/components/customer/ResetPasswordForm.vue"));
Vue.component("forgot-password-modal", () => import("./app/eros/components/customer/login/ForgotPassword.vue"));
Vue.component("login", () => import("./app/eros/components/customer/login/Login.vue"));
// legacy non-shopbuilder component
Vue.component("login-view", () => import("./app/eros/components/customer/login/LoginView.vue"));
import UserLoginHandler from "./app/eros/components/customer/login/UserLoginHandler.vue";
Vue.component("user-login-handler", UserLoginHandler);
Vue.component("form-attachment", () => import("./app/ceres/components/form/FormAttachment.vue"));

Vue.component("item-bundle", () => import("./app/ceres/components/item/ItemBundle.vue"));
Vue.component("quantity-input", () => import("./app/eros/components/item/QuantityInput.vue"));

Vue.component("tag-list", () => import("./app/ceres/components/item/TagList.vue"));

Vue.component("category-item", () => import("./app/eros/components/itemList/CategoryItem.vue"));
import ItemSearch from "./app/eros/components/itemList/ItemSearch.vue";
Vue.component("item-search", ItemSearch);
Vue.component("search-suggestion-item", () => import("./app/ceres/components/itemList/SearchSuggestionItem.vue"));
Vue.component("item-filter-tag-list", () => import("./app/ceres/components/itemList/filter/ItemFilterTagList.vue"));

// Vue.component("live-shopping-item", () => import("./app/ceres/components/liveShopping/LiveShoppingItem.vue"));

// Vue.component("newsletter-input", () => import("./app/ceres/components/newsletter/NewsletterInput.vue"));
// Vue.component("newsletter-unsubscribe-input", () =>
// 	import("./app/ceres/components/newsletter/NewsletterUnsubscribeInput.vue")
// );

Vue.component("order-return", () => import("./app/eros/components/orderReturn/OrderReturn.vue"));

import Icon from "./app/eros/components/pageDesign/Icon.vue";
Vue.component("icon", Icon);
import LanguageDetection from "./app/eros/components/pageDesign/LanguageDetection.vue";
Vue.component("language-detection", LanguageDetection);
import MobileNavigation from "./app/eros/components/pageDesign/MobileNavigation.vue";
Vue.component("mobile-navigation", MobileNavigation);
import Notifications from "./app/ceres/components/pageDesign/Notifications.vue";
Vue.component("notifications", Notifications);
Vue.component("popper", () => import("./app/eros/components/pageDesign/Popper.vue"));

Vue.component("wish-list", () => import("./app/ceres/components/wishList/WishList.vue"));
import WishListCount from "./app/ceres/components/wishList/WishListCount.vue";
Vue.component("wish-list-count", WishListCount);

import LazyLoad from "./app/ceres/components/common/LazyLoad.vue";
Vue.component("lazy-load", LazyLoad);
import AbtestCurtain from "./app/eros/components/common/AbtestCurtain.vue";
Vue.component("abtest-curtain", AbtestCurtain);

Vue.component("add-to-wish-list", () => import("./app/ceres/components/item/AddToWishList.vue"));
Vue.component("graduated-prices", () => import("./app/ceres/components/item/GraduatedPrices.vue"));
Vue.component("item-data-table", () => import("./app/eros/components/item/ItemDataTable.vue"));
Vue.component("item-price", () => import("./app/eros/components/item/ItemPrice.vue"));
Vue.component("set-price", () => import("./app/ceres/components/item/SetPrice.vue"));
Vue.component("order-property-list", () => import("./app/ceres/components/item/OrderPropertyList.vue"));
Vue.component("variation-select", () => import("./app/eros/components/item/VariationSelect.vue"));
Vue.component("item-availability", () => import("./app/eros/components/item/ItemAvailability.vue"));
Vue.component("single-item-bundle", () => import("./app/ceres/components/item/SingleItemBundle.vue"));
Vue.component("item-manufacturer", () => import("./app/ceres/components/item/ItemManufacturer.vue"));
Vue.component("item-manufacturer-data-list", () => import("./app/ceres/components/item/ItemManufacturerDataList.vue"));
Vue.component("item-eu-responsible-data-list", () => import("./app/ceres/components/item/ItemEuResponsibleDataList.vue"));
Vue.component("manufacturer-details", () => import("./app/ceres/components/item/ManufacturerDetails.vue"));
Vue.component("eu-responsible-details", () => import("./app/ceres/components/item/EuResponsibleDetails.vue"));
Vue.component("set-quantity-input", () => import("./app/ceres/components/item/SetQuantityInput.vue"));
Vue.component("event-tracker", () => import("./app/eros/components/common/EventTracker.vue"));
import CategoryContent from "./app/eros/components/common/CategoryContent.vue";
Vue.component("category-content", CategoryContent);
import Prefetch from "./app/eros/components/common/Prefetch.vue";
Vue.component("prefetch", Prefetch);

import LazyHydrate from "vue-lazy-hydration";
Vue.component("lazy-hydrate", LazyHydrate);
import ClientOnly from "./app/ceres/components/common/ClientOnly.vue";
Vue.component("client-only", ClientOnly);
import BackgroundImg from "./app/ceres/components/common/BackgroundImg.vue";
Vue.component("background-img", BackgroundImg);
import BrevoNewsletterForm from "./app/eros/components/common/BrevoNewsletterForm.vue";
Vue.component("brevo-newsletter-form", BrevoNewsletterForm);

// =========================
// DIRECTIVES
// =========================
import "./app/ceres/directives/basket/basketItemQuantity";
import "./app/ceres/directives/basket/basketItemSum";
import "./app/ceres/directives/basket/toggleBasketPreview";

import "./app/ceres/directives/category/openFilterToolbar";

import "./app/ceres/directives/common/truncateTooltip";

import "./app/eros/directives/customer/logout";

import "./app/ceres/directives/helper/testingAttr";
import "./app/ceres/directives/helper/validate";
import "./app/ceres/directives/helper/waitingAnimation";
import "./app/eros/directives/helper/waitingAnimationInfinite";
import "./app/eros/directives/helper/mutationObserver";
import "./app/eros/directives/helper/populateStore";

import "./app/ceres/directives/navigation/navigationTouchHandler";
import "./app/eros/directives/navigation/openMobileNavigation";
import "./app/eros/directives/header/openLanguageControl";

import "./app/ceres/directives/pageDesign/scrollToTop";
import "./app/ceres/directives/pageDesign/stickInParent";
import "./app/eros/directives/navigation/sidenavigationChildrenLoader";
import "./app/eros/directives/pageDesign/tooltip";

// =========================
// FILTERS
// =========================
import "./app/ceres/filters/hasItemDefaultPrice.filter";
import "./app/ceres/filters/itemCrossPrice.filter";
import "./app/ceres/filters/itemImage.filter";
import "./app/ceres/filters/itemImageHeight.filter";
import "./app/ceres/filters/itemImageWidth.filter";
import "./app/ceres/filters/itemImages.filter";
import "./app/ceres/filters/itemName.filter";
import "./app/ceres/filters/itemPrice.filter";
import "./app/ceres/filters/itemUrl.filter";
import "./app/eros/filters/currency.filter";
import "./app/ceres/filters/itemImageAlternativeText.filter";
import "./app/ceres/filters/numberFormat.filter";
// import "./app/ceres/filters/ageRestriction.filter";
// import "./app/ceres/filters/arrayFirst.filter";
// import "./app/ceres/filters/attachText.filter";
// import "./app/ceres/filters/date.filter"; (is on checkout,js)
// import "./app/ceres/filters/fileName.filter";
// import "./app/ceres/filters/fileUploadPath.filter";
// import "./app/ceres/filters/graduatedPrice.filter";
// import "./app/ceres/filters/inputUnit.filter";
// import "./app/ceres/filters/itemBundleName.filter"; (is on checkout.js)
// import "./app/ceres/filters/propertySurcharge.filter";
// import "./app/ceres/filters/propertyFileUrl.filter";
// import "./app/ceres/filters/translate.filter";
import "./app/eros/filters/itemImagesUrlOverwrite.filter";

// =========================
// MIXINS
// =========================
import "./app/ceres/mixins/getJsonData.mixin";
import "./app/ceres/mixins/template.mixin";

// =========================
// Bootstrap frameworks
// =========================
import "./app/eros/main";

// =========================
// Common
// =========================
import "./app/eros/common/carouselMobileCheck";
import "./app/eros/common/registerMutationObserver";

// =========================
// plentymarkets Plugins
// =========================
// Vue.component("sofort-history-payment-status-changer", () => import("./app/eros/plugins/plentymarkets/sofort/sofortHistoryPaymentStatusChanger.vue"));

import TranslationService from "./app/ceres/services/TranslationService";
import { createStore, initClientListeners, initClientStore, initServerStore } from "./app/eros/store";
import { initListener } from "./app/ceres/services/ApiService";

window.ceresTranslate = TranslationService.translate;

Vue.prototype.$translate = TranslationService.translate;
Vue.prototype.$ceres = App;

const store = createStore();

window.ceresStore = store;

initServerStore(store);
initClientStore(store);
initClientListeners(store);
initListener();
